// src/App.js

import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import ContactUsPage from "./pages/ContactUsPage";
import GalleryPage from "./pages/GalleryPage";
import LoginPage from "./pages/LoginPage";
import CheckResult from "./pages/CheckResult";
import Blog from './pages/Blog';
import AdmissionPage from './pages/AdmissionPage';

import "./styles/App.css";
import "./styles/index.css";

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactUsPage />} />
          <Route path="/gallery" element={<GalleryPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/result" element={<CheckResult />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/admision" element={<AdmissionPage />} />

        </Routes>
      </div>
    </Router>
  );
}

export default App;
